import { Box, Paper } from "@mui/material";
import MuiStepper from "../../components/stepper/muiStepper.component";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchCropsStart } from "../../store/features/crops/cropsSlice";
import { fetchIrrigationTypesStart } from "../../store/features/irrigationTypes/irrigationTypesSlice";
import { fetchFieldsTypeStart } from "../../store/features/fieldsType/fieldsTypeSlice";
import { useIsMobile } from "../../hook/useIsMobile";

const AddFieldPage = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const crops = useSelector((state) => state.crops?.data?.data);
  const irrigationTypes = useSelector(
    (state) => state.irrigationTypes?.data?.data
  );
  const fieldsType = useSelector((state) => state.fieldsType?.data?.data);

  useEffect(() => {
    dispatch(fetchCropsStart({ accessToken: accessToken }));
    dispatch(fetchIrrigationTypesStart({ accessToken: accessToken }));
    dispatch(fetchFieldsTypeStart({ accessToken: accessToken }));
  }, [accessToken, dispatch]);

  return (
    <Box width="100%" height="100%" pt={2}>
      <Paper
        sx={{
          p: 2,
          width: "100%",
          height: "100%",
          overflowY: isMobile ? "auto" : "",
        }}
        elevation={0}
      >
        <MuiStepper
          crops={crops}
          irrigationTypes={irrigationTypes}
          fieldsType={fieldsType}
        />
      </Paper>
    </Box>
  );
};

export default AddFieldPage;
